module.exports = __webpack_public_path__ + "media/images/icon_check-9bd83b34.png";